import { Observable } from 'rxjs';
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { BaseService } from './base.service';
import { catchError, map } from 'rxjs/operators';

import { environment } from './../../../environments/environment';

@Injectable()
export class LocationService extends BaseService {

    token: string = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6ImdhYnJpZWwucG9ydG9AY2FjYXVzaG93LmNvbS5iciIsImV4cCI6MTY1NzYzMTA1MSwiYXV0aCI6eyJDbGllbnQiOnsiVXNlciI6ImdhYnJpZWwucG9ydG9AY2FjYXVzaG93LmNvbS5iciIsIlBhc3N3b3JkIjoiZkl6bk1VM1JhbVhtdWJWckdrVXAxZz09In0sIlRva2VuIjpudWxsLCJFeHBpcmVzIjoiMjAyMi0wNy0xMlQxMDowNDoxMS45NzIxMjQ4LTAzOjAwIiwiQ3JlZGVudGlhbCI6eyJVc2VyIjoiNjA0NSIsIlBhc3N3b3JkIjoidVRNdTdZTjVpNjVEb0hrVWRpaW51Zz09In19LCJyb2xlcyI6WyJEb21haW4gVXNlcnMiLCJUSSIsIlRvZG9zIiwiU1dfTml2ZWxfNCIsIkNTX0RCSU9GX1RJX1Npc3RlbWFzIiwiQ1NfREZfQ0VTX1JveWFsdGllcyIsIkNTX0NhbmFpc19FY29tbWVyY2UiLCJTaXN0ZW1hcyIsIkNhY2F1ZGlnaXRhbCIsIkNvbXBsZXhvIEludGVuc2lkYWRlIiwiQXBwbGUiLCJSTFMgQ29ycG9yYXRpdm8iLCJPTVNBZG1pbiIsIkdQVFcgMjAyMSIsIkFkbWluIENhY2F1IExvdmVycyIsIkRlc2Vudm9sdmltZW50byIsIlZQTi1Ib21lLVRJIl19.3R8yRtRt7kruwAs3TvMDW32qVTv2VzVVT8f33TjKx8k';

    constructor(
        private http: HttpClient) { super(); }

    protected obterHeaderJsonToken() {
        return {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.token}`
            })
        }
    }

    obterEndereco(token: string, cep: string, numero: string): Observable<any> {
        let response = this.http
            .get(
                environment.urlApiLocation + `/geocode/search?Address=${cep}, ${numero}&System=Fidelidade`,
                this.obterHeaderJsonTokenSap(token)
            )
            .pipe(map(this.extractData), catchError(this.serviceError));

        return response;
    }
}